import cn from 'clsx';
import { FC, ReactNode, SyntheticEvent } from 'react';

import { ColorPropsType } from '../../../types';
import Button from '../../Button';
import BoxButton from '../../Button/Box/BoxButton';

import s from './BottomActionBanner.module.scss';

export interface RightActionBannerProps {
  className?: string;
  title?: string;
  subTitle?: ReactNode;
  onClick?: () => void;
  color?: ColorPropsType;
  buttonLabel?: string;
  illustIcon?: ReactNode;
  closeButton?: boolean;
  onClose?: () => void;
}

const RightActionBanner: FC<React.PropsWithChildren<React.PropsWithChildren<RightActionBannerProps>>> = ({
  className,
  title = '',
  subTitle = '',
  buttonLabel = '',
  color = 'gray',
  closeButton = false,
  onClick,
  onClose,
  illustIcon
}) => {
  const handleClickButton = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (onClick) {
      onClick();
    }
  };

  const handleCloseButton = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (onClose) {
      onClose();
    }
  };

  return (
    <div onClick={onClick} className={cn(s.wrap, s[color], className)}>
      <div className={s.left}>
        {title && <p className={s.title}>{title}</p>}
        {subTitle && <p className={cn(s.sub_title)}>{subTitle}</p>}
        {buttonLabel && (
          <BoxButton size="small" color={color === 'gray' ? 'violet' : color} className={s.textButton} onClick={handleClickButton}>
            {buttonLabel}
          </BoxButton>
        )}
      </div>

      <div className={s.right}>
        {closeButton && (
          <div className={s.close_button}>
            <Button.Icon icon="close" onClick={handleCloseButton} color="gray.500" className="mr-2 mt-2 " />
          </div>
        )}
        {illustIcon && <div className={s.illust_icon}>{illustIcon}</div>}
      </div>
    </div>
  );
};

export default RightActionBanner;
